const throttle = {
    lastFunc: setTimeout(function () { }),
    lastCall: 0,
    run: function (func: () => any, limit: number): void {
        const context = this;
        const args = arguments;
        let delay = 0;
        clearTimeout(this.lastFunc);

        if (Date.now() - this.lastCall >= limit) {
            delay = limit;
        }
        else {
            delay = limit - (Date.now() - this.lastCall);
        }
        this.lastFunc = setTimeout(function () {
            func.apply(context, args);
            context.lastCall = Date.now();
        }, delay);
    }
}
export default throttle;


// WEBPACK FOOTER //
// ./src/utilities/throttle.js